import kebabCase from 'lodash/kebabCase';
import camelCase from 'lodash/camelCase';

const selectGameKeys = (gameObj, suffix = '') => {
  const key = Object.keys(gameObj)[0];
  const keySuffix = ` ${suffix}`;

  return {
    key: camelCase(`${key}${keySuffix}`),
    gameKey: kebabCase(`${key}${keySuffix}`),
  };
};

export default selectGameKeys;
